import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Grid, Table, Loader, Icon} from 'semantic-ui-react';
import MoveIcon from './moveIcon';

class SpecialTable extends Component {
  constructor(props) {
    super(props);
    this.state = {'activeIndex': 0};
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e, titleProps) {
    const {index} = titleProps;
    const {activeIndex} = this.state;
    const newIndex = activeIndex === index ? -1 : index;

    this.setState({'activeIndex': newIndex});
  }

  renderBody() {
    const {loading, specialOrders} = this.props;

    if (loading) {
      return (
        <Table.Row>
          <Table.Cell colSpan='9'>
            <Loader active inline='centered' />
          </Table.Cell>
        </Table.Row>
      );
    }

    if (!specialOrders.length) {
      return (
        <Table.Row>
          <Table.Cell colSpan='9'>No se encontraron registros.</Table.Cell>
        </Table.Row>
      );
    }

    return specialOrders.map((order, index) =>
      this.renderTableRow(order, index)
    );
  }

  renderTableRow(order, key) {
    return (
      <Table.Row key={key}>
        <Table.Cell>{order.partCode}</Table.Cell>
        <Table.Cell>{order.descriptionPart}</Table.Cell>
        <Table.Cell textAlign='right'>{order.stock}</Table.Cell>
        <Table.Cell textAlign='right'>{order.onOrderStock}</Table.Cell>
        <Table.Cell>{order.ICC}</Table.Cell>
        <Table.Cell>{order.SCC}</Table.Cell>
        <Table.Cell>{order.obs}</Table.Cell>
        <Table.Cell textAlign='right'>{order.partQuantity}</Table.Cell>
        <Table.Cell>{order.fob}</Table.Cell>
        <Table.Cell textAlign='center'>
          <MoveIcon order={order} />
        </Table.Cell>
      </Table.Row>
    );
  }

  renderOrdersCount() {
    const {loading, specialOrders} = this.props;

    if (loading) {
      return null;
    }

    return <strong>Total de líneas: {specialOrders.length}</strong>;
  }

  render() {
    const {activeIndex} = this.state;

    return (
      <Accordion styled fluid className='special-orders-section'>
        <Accordion.Title
          active={activeIndex === 1}
          index={1}
          onClick={this.handleClick}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column width='8'>
                <h3>Pedidos Especiales</h3>
              </Grid.Column>
              <Grid.Column width='7' textAlign='right'>
                {this.renderOrdersCount()}
              </Grid.Column>
              <Grid.Column width='1' textAlign='right'>
                <Icon name='dropdown' />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        <Accordion.Content active={activeIndex === 1}>
          <Table striped>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Código</Table.HeaderCell>
                <Table.HeaderCell>Descripción</Table.HeaderCell>
                <Table.HeaderCell>Stock</Table.HeaderCell>
                <Table.HeaderCell>OO</Table.HeaderCell>
                <Table.HeaderCell>ICC</Table.HeaderCell>
                <Table.HeaderCell>SCC</Table.HeaderCell>
                <Table.HeaderCell>OBS</Table.HeaderCell>x|
                <Table.HeaderCell>Cantidad</Table.HeaderCell>
                <Table.HeaderCell>FOB</Table.HeaderCell>
                <Table.HeaderCell>Acción</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>{this.renderBody()}</Table.Body>
          </Table>
        </Accordion.Content>
      </Accordion>
    );
  }
}

const mapStateToProps = (state) => {
  const {loadingSuggestions, generating} = state.providerStockOrders;

  return {
    'loading': loadingSuggestions || generating,
    'specialOrders': state.providerStockOrders.specialOrders,
  };
};

export default connect(mapStateToProps)(SpecialTable);
